
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { useEffect, useState } from "react";
import LeagueWelcome from "@/modules/puzzles/LeagueWelcome";
import PuzzleChallenge from "@/modules/puzzles/PuzzleChallenge";
const WELCOME_KEY = "chesshotel:puzzle-welcome:v1";
export default function PuzzleLeaguePage() {
    const [showWelcome, setShowWelcome] = useState(false);
    useEffect(() => {
        try {
            setShowWelcome(localStorage.getItem(WELCOME_KEY) !== "seen");
        }
        catch {
            setShowWelcome(true);
        }
    }, []);
    function closeWelcome() {
        setShowWelcome(false);
        try {
            localStorage.setItem(WELCOME_KEY, "seen");
        }
        catch {
            // The puzzle remains playable when browser storage is unavailable.
        }
    }
    return (<>
      <PuzzleChallenge />
      {showWelcome && <LeagueWelcome onClose={closeWelcome}/>}
    </>);
}

    async function __Next_Translate__getStaticProps__1a0f8bb3aea__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/puzzles/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a0f8bb3aea__ as getStaticProps }
  